"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMailtoUrl = exports.isWhatsappLink = exports.isPhoneUrl = exports.WHATSAPP_LINK_PREFIX = exports.PHONE_URL_REGEXP = exports.MAILTO_URL_REGEXP = void 0;
exports.MAILTO_URL_REGEXP = /^mailto:([^?]*)(?:\?subject=(.*)?)?/;
exports.PHONE_URL_REGEXP = /^tel:(.*)/;
exports.WHATSAPP_LINK_PREFIX = `https://api.whatsapp.com/send?phone=`;
const isPhoneUrl = (url) => exports.PHONE_URL_REGEXP.test(url);
exports.isPhoneUrl = isPhoneUrl;
const isWhatsappLink = (url) => url.startsWith(exports.WHATSAPP_LINK_PREFIX);
exports.isWhatsappLink = isWhatsappLink;
const isMailtoUrl = (url) => exports.MAILTO_URL_REGEXP.test(url);
exports.isMailtoUrl = isMailtoUrl;
//# sourceMappingURL=linkPatternUtils.js.map